export default __webpack_public_path__ + "static/media/prox_interfester.6ad0d121.svg";